import { Component, OnInit } from '@angular/core';
import { ChartService } from '@app/data/services/chartService';
import { SitesService } from '@app/data/services/sitesService';
import WeatherChartConfig from '@app/data/widget-config-templates/weather-chart';
import { Subscription } from 'rxjs';
import { getChartConfig } from './weather-chart-helpers';

@Component({
  selector: 'app-weather-forecast-chart',
  templateUrl: './weather-chart.component.html',
  styleUrls: ['./weather-chart.component.scss'],
})
export class WeatherForecastChartComponent implements OnInit {
  chartTitle: string = 'Weather - Forecast';
  chartOptions: any = WeatherChartConfig;
  id: string = 'weather-forecast-chart';
  noData: boolean = true;

  constructor(private chartService: ChartService, private sitesService: SitesService) {}

  ngOnInit() {
    this.sitesService.subscribe(this.handleSiteUpdate);
    this.setData();
  }

  handleSiteUpdate = ({ site }: any) => {
    if (site) {
      this.setData();
    }
  };

  setData = () => {
    this.chartService.getForecastedWeatherData().subscribe((data) => {
      this.noData = data.length === 0;
      this.chartOptions = getChartConfig(WeatherChartConfig, data, 'weather-forecast');
    });
  };
}
